import { openModal } from '@core/components/ModalStack';
import { CourseBuilderSettingsOverlayProps } from './CourseBuilderSettingsOverlay';

export async function openCourseBuilderSettingsOverlay(props: CourseBuilderSettingsOverlayProps) {
  const { CourseBuilderSettingsOverlay } = await import('./CourseBuilderSettingsOverlay');

  openModal(CourseBuilderSettingsOverlay, props);
}

export * from './CourseBuilderSettingsOverlay';
